import Axios from "axios"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

export const requestApplications = async ({ payload }) => {
  //const request = payload?.appCodes ? { appCode: payload?.appCodes } : {}
  const request = payload?.appPayload ? payload.appPayload : {}
  try {
    let data = await Axios.post("/api/application/getApplications", request)
    return data
  } catch (error) {
    throw error
  }
}

export const requestDeleteApplication = async ({ payload }) => {
  try {
    toastr.info("Action in progress...")
    let data = await Axios.delete(`/api/application/delete?appId=${payload}`)
    toastr.success(data?.message || "Application deleted successfully!")
    return data
  } catch (error) {
    throw error
  }
}

export const requestCreateApplication = async ({ payload }) => {
  try {
    toastr.info("Action in progress...")
    let response = await Axios.post("/api/application/create", payload)
    const { data = {} } = response
    if (data && data.code === 400 && data.message === "Application already exists") {
      toastr.error("Application Already Exists")
      return;
    } else {
      toastr.success("Application created successfully!!")
      return data
    }
  } catch (error) {
    throw error
  }
}

export const requestUpdateApplication = async ({ payload }) => {
  try {
    toastr.info("Action in progress...")
    let data = await Axios.put("/api/application/update", payload)
    toastr.success("Application updated successfully!")
    return data
  } catch (error) {
    throw error
  }
}
